<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    茶光站<br>
站点介绍<br>
茶光站位于深圳南山区09号片区，沙河西路与向南的西丽南路“丁”字交叉口南侧，沿沙河西路南北方向布站。A出入口为永标大厦，B出入口为西苑村住宅楼，C出入口为大沙河河堤，D出入口为横跨大沙河的西丽桥。车站采用黄色+白色基调的装饰风格，该站是地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:18	23:52	7号线	3分35秒	5分55秒<br>
太安	06:19	23:04	7号线	3分35秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:23	23:52	7号线	4分钟	5分55秒<br>
太安	06:24	23:04	7号线	4分钟	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:23	00:52	7号线	4分钟	5分55秒<br>
太安	06:24	00:04	7号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
沙河西路西侧（北）、丽苑村、西丽居委会、西丽南路<br><br>
B出入口:<br>
沙河西路西侧（南）、珠光苑、茶光工业区<br><br>
C出入口:<br>
沙河西路东侧（南）、龙珠大道<br><br>
D出入口:<br>
沙河西路东侧（北）、深圳市南山文理实验学校、圳宝花园、丽珠花园、南山区人民法院西丽人民法庭、桃源文体中心<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 西丽社区②(往南)<br>
19,36,66,74,81,101,226,237，M299，N08，高峰104<br><br>
B出入口:<br>
公交站名： 西丽社区①(往南)<br>
67,233,316,325,332,392,392区间线，M243，M343，M345，M429，M492，高峰93，高峰94<br><br>
C出入口:<br>
公交站名： 西丽社区②(往北)<br>
19,36,66,74,81,101,226,237，B604，B708，M299，N08，高峰104<br><br>
D出入口:<br>
公交站名： 西丽社区①(往北)<br>
54,233,235,316,325,332,392,392区间线，M203，M243,M343，M345，M429，M492，高峰93，高峰94<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>